import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, formatApiError } from "../lib/api";

const ClientAuthContext = createContext(null);

export function ClientAuthProvider({ children }) {
  const [client, setClient] = useState(undefined); // undefined = checking, null = logged out
  const [ready, setReady] = useState(false);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/clients/me");
      setClient(data);
    } catch {
      setClient(null);
    } finally {
      setReady(true);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const register = async (payload) => {
    try {
      const { data } = await api.post("/clients/register", payload);
      setClient(data.client);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: formatApiError(e) };
    }
  };

  const login = async (email, password) => {
    try {
      const { data } = await api.post("/clients/login", { email, password });
      setClient(data.client);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: formatApiError(e) };
    }
  };

  const logout = async () => {
    try { await api.post("/clients/logout"); } catch {}
    setClient(null);
  };

  return (
    <ClientAuthContext.Provider value={{ client, ready, register, login, logout, refresh }}>
      {children}
    </ClientAuthContext.Provider>
  );
}

export const useClientAuth = () => useContext(ClientAuthContext);
